var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class Monoprice {
    constructor(socket, state, log) {
        this.socket = socket;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: this.makeCommand([0xa5, 0x5b, 0x06, 0x01, 0xf0]),
                next: /\xa5\x5b\x06\x01\x00{8}[\s\S]/,
            },
        ];
        // controls
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const outCode = parseInt(key);
                const hexOutCode = outCode < 16 ? `0${outCode.toString(16)}` : outCode.toString(16);
                const match = yield this.socket.send(this.makeCommand([0xa5, 0x5b, 0x02, 0x01, outCode]), new RegExp(`\\xa5\\x5b\\x02\\x01\\x${hexOutCode}\\x00([\\s\\S])\\x00{5}[\\s\\S]`), tags);
                return match[1].charCodeAt(0).toString();
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const outCode = parseInt(key);
                const hexOutCode = outCode < 16 ? `0${outCode.toString(16)}` : outCode.toString(16);
                const inCode = parseInt(value);
                yield this.socket.send(this.makeCommand([0xa5, 0x5b, 0x02, 0x03, inCode, 0x00, outCode]), new RegExp(`\\xa5\\x5b\\x02\\x03\\x00\\x00\\x${hexOutCode}\\x00{5}[\\s\\S]`), tags);
                return value;
            }),
        };
        // polling
        this.polls = [{ intervalMs: 3000, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    makeCommand(data) {
        const pad = 12 - data.length;
        for (let i = 0; i < pad; i++) {
            data.push(0);
        }
        let checksum = 0;
        for (const datum of data) {
            checksum += datum;
        }
        data.push((256 - checksum) & 0x00ff);
        return AsciiText.decode(data);
    }
}
// static properties
Monoprice.driverType = 'socketDriver';
Monoprice.key = '-LX9V2m1O-7W947NVpT0';
Monoprice.baseSocketOptions = {
    commandExtractor: (buffer) => {
        for (let i = 0; i <= buffer.length - 13; i++) {
            let checksum = 0;
            for (let j = i; j <= i + 11; j++) {
                checksum += buffer.charCodeAt(j);
            }
            checksum = 256 - checksum + 256;
            // If the checksum is correct, return the command and the updated
            // buffer.
            if (checksum === buffer.charCodeAt(i + 12)) {
                const command = buffer.slice(i, i + 13);
                buffer = buffer.slice(i + 13);
                return { command, buffer };
            }
        }
        return undefined;
    },
    isBinary: true,
    sendTerminator: '',
};
Monoprice.socketOptions = [
    Object.assign(Object.assign({}, Monoprice.baseSocketOptions), { port: 4999 }),
];
